import { EAgentLevel, ECompanyType, EOpenBankType, EPaymentChannel, IAccountApplySubmit, IPageParam } from '../common';
import { ELianLianAccountStatus, ELianlianCardStatus, ELZTCardStatus } from '../lianlian';
import { IStepItem } from '@vue3/components';

export interface IPaymentAccountParam extends IPageParam {
  /** 企业编号 */
  companyNo?: string;
  /** 企业名称 */
  companyId?: number;
  /** 代理商名称 */
  agentId?: number;
  /** 代理商等级 */
  agentLevel?: EAgentLevel;
  /** 分账通道 */
  channelType?: EPaymentChannel;
}

export interface IPaymentAccount extends IPaymentAccountBtn {
  payerId?: number;
  companyId?: number;
  /** 账户连连id */
  lianId?: number;
  /** 账户编号 */
  lianNo?: string;
  /** 企业名称 */
  name?: string;
  /** 银行账号 */
  bankNo?: string;
  /** 手机号 */
  regPhone?: string;
  /**
   * 申请类型（企业或个人）
   * @description {@link ECompanyType}
   */
  type?: ECompanyType;
  /** 企业通道配置Id */
  companyChannelConfigId?: number;
  /** 分账通道 */
  channelId?: EPaymentChannel;
  /** 电子账户类型 */
  openBank?: EOpenBankType;
  /** 账户总金额（元） */
  totalAmount?: number | string;
  /** 入账冻结金额 */
  frozenBalance?: number | string;
  /** 可用总金额（元） */
  availableBalance?: number | string;
  /** 今日收款 */
  localDayInMoney?: number;
  /** 今日分账 */
  localDayOutMoney?: number;
  /** 支付冻结金额 */
  payingBalance?: number | string;
  /** 产品状态 */
  enabled?: boolean;
  /** 账户状态 */
  status?: ELianLianAccountStatus;
  /** 来账通账户状态 */
  lztStatus?: ELZTCardStatus;
  /** 结算服务费率（%） */
  settleServiceRate?: number | string;
  /** 开户时间 */
  passDate?: string;
  /** 证书地址 */
  certificateUrl?: string;
  /** 连连卡包状态 */
  accountStatus?: ELianlianCardStatus;
  /** 备注 */
  remark?: string;
  /** 法人开户意愿认证链接地址 */
  waitSignUrl?: string;
  /** 开户意愿认证链接地址 */
  openAccountWillUrl?: string;
}

export type IPaymentSpltState = Pick<
  IPaymentAccount, 'lianId' | 'availableBalance' | 'name' | 'status'| 'companyId'
>;

export interface IPaymentCreateMeta {
  /** 企业通道配置Id */
  id?: number;
  companyName?: string;
  companyId?: string;
  enabled?: boolean;
  /** 申请类型（企业或个体工商户） */
  type: ECompanyType;
  /** 分账通道 */
  channelId?: EPaymentChannel;
  /** 率（%） */
  settleServiceRate?: number;
  /** 收费类型 */
  feeType?: string;
}

export interface IPaymentAccountBtn {
  /** 分账 */
  showSplitBill: boolean;
  /** 管理 */
  showManage: boolean;
  /** 提现 */
  showWithdraw: boolean;
  /**
   * 启用或禁用
   * @description true 启用，false 禁用, undefined 都不显示
   * @default undefined
   */
  enableOrDisable?: boolean;
  /** 编辑申请（待申请状态使用） */
  showEditApply: boolean;
  /** 重新申请（待审核状态使用） */
  showReApply: boolean;
  /** 免密授权 */
  showNoPassAuth: boolean;
  /** 重新免密授权 */
  showNoPassReAuth: boolean;
  /** 去验证 */
  showVerify?: boolean;
}

/** 分账账户表单第3步 */
export interface IPAccountApplySubmit extends IAccountApplySubmit {lianNo?: string}

export interface IPersonalApplySubmit {
  /** 连连Id */
  lianId?: number;
  lianNo?: string;
  token?: string;
  /** 验证码 */
  verifyCode?: string;
  /** 支付密码 */
  payPassword?: string;
  /** 随机因子 */
  randomKey?: string;
}

export interface IParymentConfirmForm {
  configId: number;
  payType: EPaymentChannel | null;
  type: ECompanyType | null;
  account: EOpenBankType | null;
}

export interface ICompanyWallet {
  /* id */
  id: number;
  /* 企业编号 */
  companyNo: string;
  /* 企业类型 */
  type: ECompanyType;
  /* 企业名称 */
  companyName: string;
  /* 企业Id */
  companyId: number;
  /* 代理商名称 */
  agentName: string;
  /* 代理商id */
  agentId: number;
  /* 代理商等级 */
  agentLevel: EAgentLevel;
  /* 关联id 连连/易宝 */
  relatedAccountId: number;
  /* 通道id */
  channelType: EPaymentChannel;
  /* 通道费率 */
  rateNum: number;
  /* 待结算金额 */
  frozenBalance: number;
  /* 可分账金额 */
  unAllocatedAmount: number;
  /* 本月退款金额 */
  refundAmount: number;

}

export enum EPaymentStepKey {
  License = 'license',
  Legal = 'legal',
  AccOpening = 'accOpening',
  Beneficiary = 'beneficiary',
  Store = 'store',
  Submit = 'submit',
  Submited = 'submited',
  NoPassAuth = 'noPassAuth',
}

export function getPaymentSteps(storeType: ECompanyType): IStepItem<EPaymentStepKey>[] {
  return [
    {
      title: '上传营业执照',
      key: EPaymentStepKey.License,
    },
    {
      title: `上传${storeType === ECompanyType.Company ? '法人' : '经营者'}信息`,
      key: EPaymentStepKey.Legal,
    },
    {
      title: `上传开户${storeType === ECompanyType.Company ? '许可' : '绑卡'}信息`,
      key: EPaymentStepKey.AccOpening,
    },
    storeType === ECompanyType.Company
      ? {
        title: '添加受益人',
        key: EPaymentStepKey.Beneficiary,
      }
      : undefined,
    {
      title: '绑定店铺信息',
      key: EPaymentStepKey.Store,
    },
    {
      title: `支付${storeType === ECompanyType.Company ? '信息' : ''}认证`,
      key: EPaymentStepKey.Submit,
    },
    {
      title: '免密授权',
      key: EPaymentStepKey.NoPassAuth,
    },
  ].filter(Boolean);
}

export function getPrevPaymentStep(current: EPaymentStepKey, storeType: ECompanyType): IStepItem<EPaymentStepKey> | undefined {
  const steps = getPaymentSteps(storeType);
  const index = steps.findIndex((item) => item.key === current);

  return steps[index - 1];
}

export function getPaymentStep(current: EPaymentStepKey, storeType: ECompanyType): IStepItem<EPaymentStepKey> | undefined {
  const steps = getPaymentSteps(storeType);

  return steps.find((item) => item.key === current);
}

export enum ESignmentType {
  /** 商户入网 */
  MER_REGISTER = 'MER_REGISTER',
  /** 线下收款开通 */
  OFFLINE_RECEIPT = 'OFFLINE_RECEIPT',
  /** 公域收款开通 */
  PUBLIC_COLLECTION = 'PUBLIC_COLLECTION',
  /** 产品费率变更 */
  PRODUCT_FEE_MODIFY = 'PRODUCT_FEE_MODIFY',
}

export const signmentTypeLabel = {
  [ESignmentType.MER_REGISTER]: '商户入网',
  [ESignmentType.OFFLINE_RECEIPT]: '线下收款开通',
  [ESignmentType.PUBLIC_COLLECTION]: '公域收款开通',
  [ESignmentType.PRODUCT_FEE_MODIFY]: '产品费率变更',
};

export const signmentTypeOptions = Object.keys(ESignmentType).map((key) => ({
  label: signmentTypeLabel[key],
  value: key,
}));

export interface IUnSignQuery extends IPageParam {
  /** 企业编号 */
  companyCode?: string;
  /** 企业id */
  companyId?: string;
  /**
   * 协议签署类型
   * @description {@link ESignmentType}
   */
  agreementSigningType?: ESignmentType;
}

export interface IUnSignDetail {
  agentId?: number;
  /** 代理商编号 */
  agentCode?: string;
  /** 所属代理商 */
  agentName?: string;
  /** 代理商等级 */
  agentLevel?: EAgentLevel;
  companyId?: number;
  /** 企业编号 */
  companyCode?: string;
  /** 企业名称 */
  companyName?: string;
  /** 支付通道 */
  channel?: string;
  /**
   * 协议签署类型
   * @description {@link ESignmentType}
   */
  agreementSigningType?: ESignmentType;
  /** 协议签署链接 */
  agreementSignUrl?: string;
}
